import i18next from 'i18next';

i18next.addResources('es', 'eventTypeSelector', {
  eventTypes: 'Tipos',
  workshop: 'Taller',
  meeting: 'Webinar',
  conference: 'Conferencia',
  training: 'Capacitación',
  seminar: 'Seminario'
});

i18next.addResources('en', 'eventTypeSelector', {
  eventTypes: 'Types',
  workshop: 'Workshop',
  meeting: 'Webinar',
  conference: 'Conference',
  training: 'Training',
  seminar: 'Seminar'
});

i18next.addResources('pt', 'eventTypeSelector', {
  eventTypes: 'Tipos',
  workshop: 'Oficina',
  meeting: 'Webinar',
  conference: 'Conferência',
  training: 'Capacitação',
  seminar: 'Seminário'
});
